<template>
    <div class="card" data-toggle="lists">
        <div class="card-header">
            <div class="row align-items-center">
                <div class="col">
                    <!-- Search -->
                    <div class="row align-items-center">
                        <div class="col-auto pr-0">
                            <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                            <span class="fe fe-search text-muted" v-else></span>
                        </div>
                        <div class="col">
                            <input
                                type="search"
                                v-model="query"
                                class="form-control form-control-flush search no-glow"
                                :placeholder="$t('Search')"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-auto">
                    <div class="dropdown"></div>
                </div>
                <div class="col-auto">
                    <div class="dropdown">
                        <button
                            class="btn btn-primary"
                            @click="openModal({id:'SupplyModal', model:supplyDefaults})"
                        >{{$t('Add supply')}}</button>
                    </div>
                </div>
            </div>
        </div>

        <simple-table :data="items" :loading="areDataLoading" :edit="edit" :deleteItem="deleteItem" :columns="columns"></simple-table>
        <supply-modal id="SupplyModal" :data="model"></supply-modal>
    </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable.vue'
import SupplyModal from './SupplyModal';
import currency from '@/filters/currency.js';
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    props: ['productId'],
    mixins: [modalMixins],
    components: {
        SimpleTable,
        SupplyModal,
    },
    data() {
        return {
            query: null,
            supplyDefaults: {
                productId: this.productId,
                expireOn: this.$moment().add(1, 'year').startOf('month').format('YYYY-MM-DD')
            },

            params: {
                query: {
                    // $limit: this.perPage,
                    // $skip: (this.currentPage - 1) * this.perPage,
                    productId: this.productId,
                    $sort: 'createdAt',
                    // $order: -1
                }
            },
            columns: [
                {
                    label: '',
                    name: 'current',
                    field(item) {
                        if (item.current)
                            return '<i class="fe fe-star text-info"  />';
                    }

                },
                {
                    label: 'Supply date',
                    name: 'supplyOn',
                    date_format: 'DD MMMM,  Y'
                },
                {
                    label: 'Expire date',
                    name: 'expireOn',
                    date_format: 'MMMM,  Y'
                },
                {
                    label: 'Supplier',
                    name: 'supplierId',
                    field(item) {
                        if (item.supplier)
                            return item.supplier.label;
                    },
                    subtitle(item) {
                        if (item.supplier && item.supplier.contacts)
                            return item.supplier.contacts.primaryPhone;
                    }
                },
                {
                    label: 'Left over',
                    name: 'quantity',
                    field: (item) => {
                        let measurement = (item.measurement) ? '' + this.$t(item.measurement) : '';
                        return `${item.quantity}` + measurement;

                    }
                },
                {
                    label: 'Initial quantity',
                    name: 'initialQuantity',
                    field: (item) => {
                        let measurement = (item.measurement) ? '' + this.$t(item.measurement) : '';
                        return `${item.initialQuantity}` + measurement;

                    }
                },
                {
                    label: 'Price',
                    name: 'price',
                    money: true,

                },
                {
                    label: 'Retail price',
                    name: 'retailPrice',
                    money: true,
                },

            ]

        }
    },
    computed: {
        ...mapState('supplies', { areDataLoading: 'isFindPending' }),
        ...mapGetters('supplies', {
            findDatasInStore: 'find',
        }),
        ...mapGetters('suppliers', {
            findSupplierInStore: 'find',
            getSupplierById: 'get'
        }),

        items() {

            let items = this.findDatasInStore(this.params).data;
            // items.map(item => {
            //     item.supplier = this.getSupplierById(item.supplierId);
            // })
            return items;
        },

    },
    created() {
        this.fetchSupliers().then(data => {
            this.fetchItems();
        });

    },
    methods: {
        ...mapActions('supplies', ['find', 'remove', 'create', 'patch']),
        ...mapActions('suppliers', { fetchSupliers: 'find' }),
        fetchItems() {

            this.find(this.params).then(result => {
                this.totalRows = result.total;
            });
        },
        edit(item) {
            this.openModal({ id: 'SupplyModal', model: item });
        },
        deleteItem(item) {
            this.remove(item._id);
        }
    }



}
</script>

<style>

</style>
